import { Link } from "react-router-dom";
import { categories } from "@/mocks/news";
import { getHotArticles } from "@/utils/news";

const hotList = getHotArticles(6);

export default function ArticleSidebar() {
  return (
    <aside className="space-y-6">
      <div className="rounded-lg border border-background-200 bg-background-100 p-5">
        <h2 className="mb-4 flex items-center gap-2 font-serif-cn text-base font-bold text-foreground-950">
          <i className="ri-fire-fill text-primary-500" />
          热榜推荐
        </h2>
        <ol className="space-y-3">
          {hotList.map((item, index) => (
            <li key={item.id}>
              <Link to={`/article/${item.id}`} className="group flex items-start gap-3">
                <span
                  className={`flex h-5 w-5 shrink-0 items-center justify-center rounded font-serif-cn text-xs font-bold ${
                    index < 3
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-300 text-foreground-700"
                  }`}
                >
                  {index + 1}
                </span>
                <span className="line-clamp-2 text-sm leading-snug text-foreground-800 transition group-hover:text-primary-600">
                  {item.title}
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 className="mb-4 flex items-center gap-2 font-serif-cn text-base font-bold text-foreground-950">
          <i className="ri-layout-grid-line text-primary-500" />
          浏览其他栏目
        </h2>
        <div className="flex flex-wrap gap-2">
          {categories.map((item) => (
            <Link
              key={item.slug}
              to={`/category/${item.slug}`}
              className="flex items-center gap-1.5 rounded-full border border-background-300 px-3 py-1.5 text-xs text-foreground-700 transition hover:border-primary-400 hover:bg-primary-50 hover:text-primary-600"
            >
              <i className={item.icon} />
              {item.name}
            </Link>
          ))}
        </div>
      </div>
    </aside>
  );
}